import React from "react";
import { Button } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

export const ErrorFallback: React.FC<{
  error: Error | null;
  retry?: () => void;
  title: string | null;
  children: any;
}> = ({ error, retry, title, children }) => {
  if (error) {
    const action = retry ? (
      <Button disableElevation color="inherit" size="small" onClick={retry}>
        Try again
      </Button>
    ) : undefined;
    return (
      <Alert severity="error" variant="outlined" action={action}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {error.message}
      </Alert>
    );
  }
  return <>{children}</>;
};
